import { useSuiTurnstileState } from "schoolUiComponents/SuiTurnstile";
import { APIS } from "../api";
import React, { useEffect, useState } from "react";

const INITIAL_STATE = ["", "", "", "", "", ""];

export const KlassCodeInput = () => {
  const [klassCode, setKlassCode] = useState([...INITIAL_STATE]);
  const [focusedBox, setFocusedBox] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [inputMethod, setInputMethod] = useState('');
  const { token, refreshToken, isTurnstileLoading } = useSuiTurnstileState();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const klassCodeValue = klassCode?.join("").trim() || "";
      if (klassCodeValue?.length === 6 && isValidText(klassCodeValue)) {
        setLoading(true);
        setSuccess(null);
        setError(null);
        trackEventsForGuests("Class Login Attempted", { "mp_login_user_type": "student", "Login Method": "Class code" }, { send_mixpanel: true })
        APIS.klassCodeLogin(klassCodeValue, false, token)
          .then((res) => {
            setLoading(false);
            setSuccess("Great job!");
            // [AI GENERATED CODE] — Set pending source before navigation so createSession picks up correct userId on next page.
            if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('klass_code');
            window.location.href = "/klass/student_roster?loginMethod=Class code&fromPage=Class code input screen";
          })
          .catch((err) => {
            setLoading(false);
            setError("Oops, try again!");
            refreshToken();
            setTimeout(() => {
              setKlassCode([...INITIAL_STATE])
              setFocusedBox(0);
            }, 1000)
          });
      } else {
        if(success) {
          setSuccess(null);
        }
        if(error) {
          setError(null);
        }
      }
    }, 200)
    return () => clearTimeout(timeout);
  }, [klassCode]);

  function isValidText(text: string) {
    var regex = /^[A-Za-z]+$/;
    return regex.test(text);
  }

  const sendInteractedEvent = ({interactionDetails = '', clickedOn = ''}) => {
    trackEventsForGuests("Interacted Class Code Input Screen", { "mp_login_user_type": "student", "Interaction details": interactionDetails,"Clicked on": clickedOn }, { send_mixpanel: true })
  }

  const handleCodeChange = (index: number, value: string) => {
    if(!isTyping && (inputMethod !== 'pasted')){
      sendInteractedEvent({interactionDetails: "Started typing"})
      setIsTyping(true)
    }
    value = value?.trim()?.split("")?.slice(0,6).join("") || "";
    if (value?.length && !isValidText(value)) {
      return;
    }
    if (value?.length > 1 && isValidText(value)) {
      setKlassCode([...klassCode.map((code, i) => (i >= index) ? (value[i-index] || code) : code)])
      setFocusedBox((index + value?.length) >= 6 ? 0 : (index + value?.length));
      return;
    }
    klassCode[index] = value?.toUpperCase() || "";
    setKlassCode([...klassCode]);
    if (value) {
      setFocusedBox((index + 1) % 6);
    } else {
      setFocusedBox(index === 0 ? 0 : (index - 1));
    }
  };

  const setDataFromClipboard = async () => {
    const text = await navigator.clipboard.readText();
    if (text?.length === 6 && isValidText(text)) {
      setKlassCode(text.split("").slice(0, 6));
      setFocusedBox(5);
    }
  };

  return (
    <div className="klass-code">
      <div className="klass-code-input">
        {klassCode.slice(0, 6).map((codeChar, index) => (
          <input
            key={`${index}-${codeChar}`}
            ref={(ref) => {
              if (index === focusedBox) {
                ref?.focus();
              }
            }}
            value={codeChar}
            onChange={({ target }) => !isTurnstileLoading && handleCodeChange(index, target?.value)}
            onPaste={(event) => {
              // setDataFromClipboard()
              setInputMethod('pasted');
              sendInteractedEvent({interactionDetails: "Copy pasted"})
            }}
            className={`code-char ${codeChar?.length ? "filled" : ""} ${
              success ? "success" : ""
            } ${error ? "error" : ""}`}
            tabIndex={index + 1}
            type="text"
            maxLength={6}
            autoComplete="off"
            autoFocus={index === focusedBox}
            data-test-id={`class-code-${index}-field`}
          />
        ))}
      </div>
      <div className="info">
        {isLoading && <div className="loading">Checking your class code…</div>}
        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}
      </div>
      <input className="autocomplete-hide"/>
    </div>
  );
};
